var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c("div", { staticClass: "line" }),
    _c("div", { staticClass: "footer-container" }, [
      _c("div", { staticClass: "item font-12 text-000" }, [
        _c(
          "div",
          {
            staticClass: "flex items-center justify-center m-b-20 friend-links",
          },
          [
            _vm._v("友情链接： "),
            _c(
              "div",
              {
                staticClass: "m-r-20",
                on: {
                  click: function ($event) {
                    return _vm.toLick("http://www.moe.gov.cn/index.html")
                  },
                },
              },
              [_vm._v("中华人民共和国教育部")]
            ),
            _c(
              "div",
              {
                staticClass: "m-r-20",
                on: {
                  click: function ($event) {
                    return _vm.toLick("https://www.mohrss.gov.cn/")
                  },
                },
              },
              [_vm._v("中华人民共和国人力资源和社会保障部")]
            ),
            _c(
              "div",
              {
                staticClass: "m-r-20",
                on: {
                  click: function ($event) {
                    return _vm.toLick("https://jyt.yn.gov.cn/")
                  },
                },
              },
              [_vm._v("云南省教育厅")]
            ),
            _c(
              "div",
              {
                staticClass: "m-r-20",
                on: {
                  click: function ($event) {
                    return _vm.toLick("https://hrss.yn.gov.cn/index.html")
                  },
                },
              },
              [_vm._v("云南人力资源和社会保障网")]
            ),
            _c(
              "div",
              {
                staticClass: "m-r-20",
                on: {
                  click: function ($event) {
                    return _vm.toLick("https://www.ynwsjkrc.cn/")
                  },
                },
              },
              [_vm._v("云南卫生健康人才网")]
            ),
            _c(
              "div",
              {
                staticClass: "m-r-20",
                on: {
                  click: function ($event) {
                    return _vm.toLick("https://rsj.km.gov.cn/")
                  },
                },
              },
              [_vm._v("昆明市人力资源和社会保障局")]
            ),
            _c(
              "div",
              {
                on: {
                  click: function ($event) {
                    return _vm.toLick("https://www.kmjyrc.com/")
                  },
                },
              },
              [_vm._v("昆明教育人才网")]
            ),
          ]
        ),
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "text-center m-b-20" }, [
          _vm._v(
            "1366*768分辨率以上，谷歌、火狐、edge、360（非兼容模式）等浏览器"
          ),
        ]),
        _c("div", { staticClass: "text-center" }, [
          _vm._v(
            "版权所有：云南省高校人才市场，未经许可，本网站包括图像、图标、文字在内的所有数据不得转载"
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex items-center justify-center m-b-20 org-info" },
      [
        _c("div", { staticStyle: { "margin-right": "40px" } }, [
          _vm._v("主办：云南省高校人才市场"),
        ]),
        _c("div", [_vm._v("地址：昆明市翠湖北路2号")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex items-center justify-center m-b-20" },
      [_c("div", [_vm._v("备案号：滇ICP备2026010138号-1")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }